import _defineProperty from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON } from './constants';
import theme from './theme';
import sx from './sx';

function IconWrapper(_ref) {
  var IconComponent = _ref.icon,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["icon", "className"]);

  return /*#__PURE__*/React.createElement(IconComponent, _extends({
    className: className
  }, rest));
}

IconWrapper.displayName = "IconWrapper";
var StyledOcticon = styled(IconWrapper).withConfig({
  displayName: "StyledOcticon",
  componentId: "sc-7ly0uy-0"
})(["", " ", ""], COMMON, sx);
StyledOcticon.defaultProps = {
  theme: theme,
  size: 16
};
StyledOcticon.propTypes = _objectSpread(_objectSpread(_objectSpread({}, COMMON.propTypes), sx.propTypes), {}, {
  icon: PropTypes.elementType.isRequired,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['small', 'medium', 'large'])]),
  theme: PropTypes.object,
  verticalAlign: PropTypes.oneOf(['middle', 'text-bottom', 'text-top', 'top'])
});
export default StyledOcticon;